export default "__VITE_ASSET__$WK0BoAb__"